import { useState } from "react";
import { faq } from "@/mocks/content";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="guide" className="w-full bg-accent-100/40">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
        <div className="grid gap-10 lg:grid-cols-5">
          {/* intro */}
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="理性吃瓜 · 先看这里"
              title="吃瓜指南与常见问题"
              desc="第一次来大瓜？先把这几个问题看完，你就懂我们怎么求锤、怎么挖坟、怎么回踩了。"
              accent="accent"
            />
            <div className="mt-6 rounded-2xl border border-accent-200 bg-background-50 p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className="ri-question-line text-xl" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-heading text-base font-bold text-foreground-950">还是没看懂？</p>
                  <p className="text-xs text-foreground-600">联系编辑部，我们手把手教你吃瓜</p>
                </div>
              </div>
              <a
                href="mailto:editor@dagu-media.cn"
                className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-send-line" aria-hidden="true" /> editor@dagu-media.cn
              </a>
            </div>
          </div>

          {/* accordion */}
          <div className="lg:col-span-3">
            <div className="space-y-3">
              {faq.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-xl border transition-colors ${
                      isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50/60 hover:border-background-300"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="font-heading text-[15px] font-bold text-foreground-950">{f.q}</span>
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                          isOpen ? "rotate-45 text-primary-600" : ""
                        }`}
                        aria-hidden="true"
                      >
                        {isOpen ? "ri-add-line" : "ri-add-line"}
                      </i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="border-t border-background-100 px-5 pb-5 pt-4 pl-[60px] text-sm leading-relaxed text-foreground-600">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}